(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      var dialog = document.getElementById(opener.dataset.sizeGuideOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var section = opener.closest('.product-option');
      var selected = section && section.querySelector('.option-btn.is-selected');
      var current = selected ? selected.dataset.value.toLowerCase().replace(/cm|\s/g, '') : '';
      dialog.querySelectorAll('.size-guide__item').forEach(function (item) {
        item.classList.toggle('is-current', item.dataset.size === current);
      });
      dialog.showModal();
      return;
    }
    var dialogEl = event.target.closest('dialog.size-guide');
    if (!dialogEl) return;
    if (event.target.closest('[data-size-guide-close]') || event.target === dialogEl) dialogEl.close();
  });
  } catch(e) { console.error(e); }
})();

})();
